import { createStore, getActionIds } from '../helpers/redux';
import Immutable from 'immutable';

import { InlineEditorActions } from '../actions/inlineEditor';
import { ProjectActions } from '../actions/project';

const projectActions = getActionIds(ProjectActions);
const inlineEditorActions = getActionIds(InlineEditorActions);

const initialState = Immutable.fromJS({
  editors: {
    // 0: "value"
  },
});

export const inlineEditors = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [inlineEditorActions.setInlineEditState]: (state, action) => {
    return state.mergeDeep({
      editors: {
        [action.uid]: action.value
      }
    });
  },

  [inlineEditorActions.unsetInlineEditState]: (state, action) => {
    return state.deleteIn(['editors', action.uid]);
  },
});

export const inlineEditorSelector = (state) =>
  state.inlineEditors.get('editors');



// WEBPACK FOOTER //
// ./src/reducers/inlineEditors.js